export default __webpack_public_path__ + "static/media/plusIcon.c637562f.svg";